import { render, staticRenderFns } from "./UploadScanning.vue?vue&type=template&id=e6213e84&scoped=true"
import script from "./UploadScanning.vue?vue&type=script&lang=js"
export * from "./UploadScanning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6213e84",
  null
  
)

export default component.exports